import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi/BookingManagerApi';
import { BANK_TRANSACTIONS_QUERY_KEY } from './useBankTransactionsQueries';

/**
 * Mutation hook for deleting a bank transaction.
 * Only transactions with ACTION_REQUIRED status can be deleted.
 * OWA-10234
 */
export const useDeleteBankTransaction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (transactionUuid: string) => {
      const api = makeBookingManagerApi();
      await api.deleteBankTransaction(transactionUuid);
    },
    onSuccess: () => {
      // Invalidate bank transactions query to refetch the list
      queryClient.invalidateQueries({
        queryKey: [BANK_TRANSACTIONS_QUERY_KEY],
      });
    },
  });
};
